export default {
  methods: {
    goToPageTemplates() {
      this.$router.push({
        name: ENUMS.ROUTES.DASHBOARD.PAGE_TEMPLATES,
      });
    },
  },
};
